import React from 'react';
import CGILogoImage from '../../img/cgi-main-logo.png';
import './CGILogo.css';

export const CGILogo = () => {
	return (
		<>
			<div className="cgi-logo-container">
				<img src={CGILogoImage} alt="CGI Logo" />
			</div>
		</>
	);
};

export default CGILogo;
